$ = jQuery;
$(document).ready(function () {

    var countries;
    var pathname = window.location.host;

    var url = '';
    if (pathname == "115.113.146.196") {
        url = '/habitat';
    }

    //$.ajax({
    //    url: url + "/getuacountrytooltip",
    //    type: 'GET',
    //    async: false,
    //    success: function (data) {
    //        countries = JSON.parse(data);
    //        getCountries();
    //
    //    }
    //    });

    var regions = [
        {
            name: 'Africa',
            radius: 7,
            class: 'region-pin',
            latitude: 15.44,
            longitude: 18.73,
        },
        {
            name: 'Asia Pacific',
            radius: 7,
            class: 'region-pin',
            latitude: 35.85,
            longitude: 104.13,
        },
        {
            name: 'Eastern Europe',
            radius: 7,
            class: 'region-pin',
            latitude: 55.0,
            longitude: 80.0,
        },
        {
            name: 'Latin America and Caribbean',
            radius: 7,
            class: 'region-pin',
            latitude: -23.43,
            longitude: -58.44,
        },
        {
            name: 'Western Europe',
            radius: 7,
            class: 'region-pin',
            latitude: 56.0,
            longitude: -96.0,
        }
    ];


    var mapWrapperHeight = $(".map-main-wrapper .homepage-map-img").height();
    var mapWrapperWidth = $(".map-main-wrapper .homepage-map-img").width();
    var mapElements = $('.urban-agenda-action-map,.map-main-wrapper');
    mapElements.css("height", mapWrapperHeight + 'px');
    mapElements.css("width", mapWrapperWidth + 'px');


    // this.$container = $("#urban-agenda-action-map");
    //basic map config with custom fills, mercator projection
    if ($("#urban-agenda-action-map").length > 0) {
        var basic_choropleth = new Datamaps({
            element: document.getElementById('urban-agenda-action-map'),
            scope: 'world',
            responsive: false,
            projection: 'mercator',
            geographyConfig: {
                dataUrl: null,
                hideAntarctica: true,
                borderWidth: 1,
                borderOpacity: 1,
                borderColor: 'transparent',
                popupTemplate: function (geography, data) { //this function should just return a string
                    return '<div class="hoverinfo"><strong>' + geography.properties.name + '</strong></div>';
                },
                popupOnHover: false, //disable the popup while hovering
                highlightOnHover: false,
                highlightFillColor: 'transparent',
                highlightBorderColor: 'transparent',
                highlightBorderWidth: 0,
                highlightBorderOpacity: 0
            },
            fills: {
                defaultFill: "transparent",
                stroke: "transparent",
                authorHasTraveledTo: "transparent"
            },
        });

        basic_choropleth.addPlugin('pins', function (layer, data, options) {
            var self = this,
                fillData = this.options.fills,
                svg = this.svg;

            if (!data || (data && !data.slice)) {
                throw "Datamaps Error - bubbles must be an array";
            }
            console.log(data);
            var pinClass = data[0].class;


            var bubbles = layer.selectAll('image.datamaps-pins').data(data, JSON.stringify);
            var pinSize = 20;
            bubbles.enter()
                .append('image')
                .attr('class', 'datamaps-pin ' + pinClass)
                .attr('xlink:href', document.getElementById('siteurl').value + '/themes/custom/habitat/images/map_pin_normal.svg')
                .attr('height', pinSize)
                .attr('width', pinSize)
                .attr('x', function (datum) {
                    var latLng;
                    if (datumHasCoords(datum)) {
                        latLng = self.latLngToXY(datum.latitude, datum.longitude);
                    } else {
                        if (datum.centered == 'USA') {
                            latLng = self.latLngToXY(37, -97);
                        } else {
                            latLng = self.path.centroid(d3.select('path.' + datum.centered).data()[0]);
                        }
                    }
                    if (latLng)
                        var xc = latLng[0];
                    if (!isNaN(xc)) {
                        datum.realx = xc;
                        return xc;
                    }
                    if (latLng)
                        return latLng[0] - pinSize / 2;
                })
                .attr('y', function (datum) {
                    var latLng;
                    if (datumHasCoords(datum)) {
                        latLng = self.latLngToXY(datum.latitude, datum.longitude);
                    } else {
                        if (datum.centered == 'USA') {
                            latLng = self.latLngToXY(37, -97);
                        } else {
                            latLng = self.path.centroid(svg.select('path.' + datum.centered).data()[0]);
                        }
                    }

                    if (latLng)
                        var xy = latLng[1];
                    if (!isNaN(xy)) {
                        datum.realy = xy;
                        return xy;
                    }
                    if (latLng)
                        return latLng[1] - pinSize;
                }).on('mouseover', function (datum, event) {
                    $('.datamaps-pin').attr('href', document.getElementById('siteurl').value + '/themes/custom/habitat/images/map_pin_normal.svg');
                    var $this = d3.select(this);
                    $this.attr('xlink:href', document.getElementById('siteurl').value + '/themes/custom/habitat/images/map_pin_active.svg');

                    generateTooltip(datum);
                })
                .on('click', function (datum, event) {
                    console.log(datum.class);

                    $('.datamaps-pin').attr('href', document.getElementById('siteurl').value + '/themes/custom/habitat/images/map_pin_normal.svg');

                    var $this = d3.select(this);
                    $this.attr('xlink:href', document.getElementById('siteurl').value + '/themes/custom/habitat/images/map_pin_active.svg');
                    if (datum.class == "region-pin") {
                        d3.selectAll('g image.country-pin').remove();
                        d3.select(".map-tooltip").style("display", "none");

                        $.ajax({
                            url: url + "/getuacountrytooltip",
                            type: 'GET',
                            data: {
                                region: datum.name,
                            },
                            async: false,
                            success: function (data) {
                                var countries = JSON.parse(data);
                                getCountriesPins(countries);
                                d3.selectAll('g image.region-pin').style("display", "none");
                            }
                        });
                    } else {
                        generateTooltip(datum);
                    }
                })


            bubbles.exit()
                .transition()
                .delay(options.exitDelay)
                .attr("height", 0)
                .remove();

            function datumHasCoords(datum) {
                return typeof datum !== 'undefined' && typeof datum.latitude !== 'undefined' && typeof datum.longitude !== 'undefined';
            }

        });

        //bubbles, custom popup on hover template
        basic_choropleth.pins(regions, {
            popupOnHover: true,
            popupTemplate: function (data) {
                return "<div class='hoverinfo'>It is " + data.name + "</div>";
            }
        });
        function getCountriesPins(countries) {
            if (countries) {
                for (var i = 0; i < countries.length; i++) {

                    basic_choropleth.pins(
                        [
                            {
                                name: countries[i].country_name,
                                field_ms_node_field_data_nid: countries[i].field_ms_node_field_data_nid,
                                nid: countries[i].nid,
                                radius: 7,
                                class: 'country-pin',
                                centered: countries[i].centered,
                            },
                        ]
                    );
                }
            }

        }

        function generateTooltip(datum) {


            $(".map-tooltip").empty();

            var hrefurl
            if (datum.class == "region-pin") {
                hrefurl = '#';
            } else {
                var nodeId;
                if (datum.field_ms_node_field_data_nid != null) {
                    nodeId = datum.field_ms_node_field_data_nid;
                } else {
                    nodeId = datum.nid;
                }
                hrefurl = url + "/node/" + nodeId;
            }

            var tooltipHtml = "<a class='tooltip-link d-flex justify-content-end' href=" + hrefurl + ">" + datum.name + "</a>";
            $(".map-tooltip").append(tooltipHtml);
            $(".map-tooltip").removeClass('d-none');
            var containerOffset = $(".map-container").offset();
            var containerOffset = $(".map-main-wrapper").offset();
            var left = d3.event.pageX - containerOffset.left - ($('.map-tooltip').outerWidth() / 2);
            var top = d3.event.pageY - containerOffset.top;
            $(".map-tooltip").show();
            $(".map-tooltip").css("left", left + "px");
            $(".map-tooltip").css("top", top + "px");
        }

        $(".reset-map").click(function () {
            d3.select(".map-tooltip").style("display", "none");
            d3.selectAll('g image.country-pin').remove();
            d3.selectAll('g image.region-pin').style("display", "block");

        });
        Datamaps();
    }

});



